/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
const dependencies = [
  '$state', '$scope', '$q', 'RepeatableBooking', 'redirectService', 'localStorageService', 'currentUserService'
];

const ScheduleManagerRepeatableBookingLayoutController = function(
  $state, $scope, $q, RepeatableBooking, redirectService, localStorageService, currentUserService
) {

  const vm = this;

  vm.activeStepNumber = 1;
  vm.holderWidth = null;
  vm.isLoading = false;
  vm.isInitialized = false;

  let cachedRepeatableBooking;
  let isFinishedBooking = false;

  vm.$onInit = function() {
    vm.isLoading = true;
    vm.repeatableBookingId = $state.params.id || localStorageService.get('repeatableBookingId');
    vm.loadRepeatableBooking().then((repeatableBooking) => {
      vm.isEdit = !!repeatableBooking.clonedFromId;
      initSteps();
      initActiveStepNumber();
      vm.isLoading = false;
      vm.isInitialized = true;
    });
  };

  vm.getTitle = () => vm.steps[vm.activeStepNumber - 1].title;

  vm.goBack = () => $state.go(vm.steps[vm.activeStepNumber - 2].sref);

  vm.goNext = function() {
    if (vm.steps[vm.activeStepNumber]) {
      $state.go(vm.steps[vm.activeStepNumber].sref);
    } else {
      if (isFinishedBooking) { return; }
      isFinishedBooking = true;
      vm.loadRepeatableBooking().then((repeatableBooking) => {
        vm.isLoading = true;
        currentUserService.getCurrentProfile().isSavingRepeatableBooking = true;
        localStorageService.remove('repeatableBookingId');
        repeatableBooking.finish();
        redirectFromForm();
      });
    }
  };

  vm.getHolderClass = function() {
    if (vm.holderWidth) {
      return `mod-w${vm.holderWidth}`;
    }
  };

  vm.loadRepeatableBooking = function() {
    if (cachedRepeatableBooking) {
      return $q.when(cachedRepeatableBooking);
    } else if (vm.repeatableBookingId) {
      return vm.reloadRepeatableBooking();
    } else {
      // is not saving without params
      return new RepeatableBooking({ name: '' }).save().then(vm.updateRepeatableBooking);
    }
  };

  vm.reloadRepeatableBooking = () => {
    return RepeatableBooking.get(vm.repeatableBookingId).then(loadedRepeatableBooking => {
      return cachedRepeatableBooking = loadedRepeatableBooking;
    }, () => redirectService.redirectToMain());
  };

  vm.updateRepeatableBooking = function(repeatableBooking) {
    if (!vm.isEdit) { localStorageService.set('repeatableBookingId', repeatableBooking.id); }
    vm.repeatableBookingId = repeatableBooking.id;
    return cachedRepeatableBooking = repeatableBooking;
  };

  const initActiveStepNumber = function() {
    const index = _.findIndex(vm.steps, step => $state.is(step.sref));
    vm.activeStepNumber = index + 1;
  };

  const initSteps = () => {
    vm.steps = [{
      title: vm.isEdit ? 'Edit repeatable booking' : 'New repeatable booking',
      sref: 'public.security-manager.schedule-manager.repeatable-booking.form'
    }, {
      title: vm.isEdit ? 'Edit shifts' : 'Create shifts',
      sref: 'public.security-manager.schedule-manager.repeatable-booking.shift-rules'
    }];
  };

  const redirectFromForm = function() {
    vm.repeatableBookingId = undefined;
    $state.go('public.security-manager.schedule-manager.timeline.booking');
  };

  $scope.$on('$stateChangeSuccess', initActiveStepNumber);

  return vm;

};

angular.module('public.security-manager.schedule-manager.repeatable-booking')
  .controller('ScheduleManagerRepeatableBookingLayoutController',
    dependencies.concat(ScheduleManagerRepeatableBookingLayoutController)
  );
